import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useLocation } from '@reach/router';

const orangeFooterLinks = ['/employee-product/', '/employer-product/', '/provider-pathway/'];

const peachFooterLinks = ['/employer-cycling/get-started/'];

const brownFooterLinks = [
	'/employee-cycling/',
	'/employer-cycling/',
	'/provider-cycling/',
	'/employee-nursery/',
	'/about-us/',
	'/b-corp/',
	'/iso/',
	'/tell-parents/',
	'/tell-customers/',
	'/blog/',
	'/gogeta-cycle-to-work-scheme/',
	'/provider-tech/',
	'/employee-tech/',
	'/employer-tech/',
	'/home-salary-sacrifice/',
	'/employee-home/',
	'/employer-home/',
	'/workplace-nursery/',
];

const useFooterColors = (): string => {
	const theme = useTheme();
	const [color, setColor] = useState(theme.colors.blueberry);
	const location = useLocation();
	useEffect(() => {
		if (brownFooterLinks.includes(location.pathname)) {
			setColor(theme.colors.toasted);
		} else if (orangeFooterLinks.includes(location.pathname)) {
			setColor(theme.colors.marmelade);
		} else if (peachFooterLinks.includes(location.pathname)) {
			setColor(theme.colors.peach);
		} else {
			setColor(theme.colors.blueberry);
		}
	}, [location, theme.colors]);

	return color;
};

export default useFooterColors;
